import { render, staticRenderFns } from "./TournamentDisciplinesCard.vue?vue&type=template&id=6f474a0e&scoped=true&"
import script from "./TournamentDisciplinesCard.vue?vue&type=script&lang=js&"
export * from "./TournamentDisciplinesCard.vue?vue&type=script&lang=js&"
import style0 from "./TournamentDisciplinesCard.vue?vue&type=style&index=0&id=6f474a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f474a0e",
  null
  
)

export default component.exports